<template>
  <vue-perfect-scrollbar
    ref="chatListScrollbar"
    class="chat-history--scrollbar"
    :class="{ admin: $auth.user().role === 'admin' }"
    @ps-y-reach-end.stop="searchChats">
    <v-list two-line class="pt-0" :class="{ 'show-search': showSearch }">
      <template v-if="chats.length">
        <template
          v-for="(chat, i) in chats">
          <v-divider
            v-if="i && i !== chats.lenght && activeChat.id !== chat.id && activeChat.id !== chats[i - 1].id"
            :key="`chat-divider-${tab}-${subtab}-${chat.id}-${i}`"
            inset>
          </v-divider>
          <v-list-tile 
          :key="`chat-list-tile-${tab}-${subtab}-${chat.id}-${i}`"
          :class="{ active: activeChat.id === chat.id }"
          :disabled="chat.disabled"
          @click="open($event, chat)" >
            <v-list-tile-avatar>
              <v-badge overlap class="custom-badge" color="k-orange-linear">
                <span slot="badge" v-if="chat.unread_messages">{{ chat.unread_messages }}</span>
                <v-icon medium class="k-orange-linear-text">{{ badgeIcons[chat.channel] }}</v-icon>
              </v-badge>
            </v-list-tile-avatar>
            <v-list-tile-content :class="{ 'text-bolder': chat.unread_messages, 'font-weight-lighter': !chat.unread_messages }">
              <v-list-tile-title class="text-capitalize">
                {{ chat.customer ? chat.customer.name || chat.customer.first_name : chat.user_name | lowerCase }}
                <small v-if="!chat.customer && chat.user_name">(Desconocido)</small>
              </v-list-tile-title>
              <v-tooltip bottom>
                <v-list-tile-sub-title slot="activator">
                  <template v-if="chat.channel === 'email'">
                    {{ chat.subject }}
                  </template>
                  <template v-else>
                    {{ formatLastMessage(chat.chat_center_messages) }}
                  </template>
                </v-list-tile-sub-title>
                <span>
                  <template v-if="chat.channel === 'email'">
                    {{ chat.subject }}
                  </template>
                  <template v-else>
                    {{ formatLastMessage(chat.chat_center_messages) }}
                  </template>
                </span>
              </v-tooltip>
              <v-list-tile-title class="text-capitalize little-text">
                <template v-if="chat.user">
                  {{chat.user.first_name}} {{chat.user.last_name}} / {{ chat.status }}
                </template>
                <template v-else>
                  {{ chat.status }}
                </template>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom offset-y>
                <v-btn slot="activator" icon ripple>
                  <v-icon color="grey lighten-1">fas fa-cog</v-icon>
                </v-btn>
                <v-list class="pa-0">
                  <v-list-tile v-if="!chat.customer" @click="assign(chat.id)">
                    <v-list-tile-title>
                      Asignar a cliente
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="reassign(chat.id)">
                    <v-list-tile-title>
                      Reasignar
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="chat.customer && chat.channel !== 'chatbot'" @click="confirm(chat.id, 'wrongPerson')">
                    <v-list-tile-title>
                      Equivocado
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </template>
      <template v-else>
        <v-list-tile class="ml-2">
          <v-list-tile-avatar>
            <v-icon medium>info_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              No se encontraron chats
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </vue-perfect-scrollbar>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import removeImgTags from '@/mixins/removeImgTags';
import removeHtmlTags from '@/mixins/removeHtmlTags';

export default {
  props: {
    tab: {
      type: Number,
      required: true,
    },
    subtab: {
      type: Number,
      required: true,
    },
    chats: {
      type: Array,
      default: () => [],
    },
    activeChat: {
      type: Object,
      default: () => {},
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 10,
    },
    activeTab: {
      type: String,
      default: '0',
    },
    activeSubTab: {
      type: String,
      default: '0',
    },
  },
  mixins: [
    removeImgTags,
    removeHtmlTags,
  ],
  components: {
    VuePerfectScrollbar,
  },
  created() {
    moment.locale('es');
  },
  data() {
    return {
      badgeIcons: {
        email: 'far fa-envelope',
        whatsapp: 'fab fa-whatsapp f2em',
        chatbot: 'fas fa-robot',
        sms: 'far fa-comment',
      },
    };
  },
  filters: {
    lowerCase(value) {
      if (value) {
        return value.toLowerCase();
      }
      return 'Desconocido';
    },
  },
  computed: {
    channel() {
      return `company.${this.$auth.user().company.id}.chatCenter`;
    },
  },
  methods: {
    open($event, chat) {
      if (!chat.disabled) {
        this.$emit('open-chat', chat.id);
      }
    },
    searchChats() {
      if (this.chats.length &&
        this.chats.length >= this.limit &&
        String(this.tab) === this.activeTab &&
        String(this.subtab) === this.activeSubTab) {
        this.$emit('search-chats');
      }
    },
    formatLastMessage(messages) {
      if (messages && messages.length) {
        const filteredMessages = _.orderBy(messages.filter(message => message && message.type === 'message'), ['created_at', 'id'], ['asc', 'asc']);
        const lastMessage = filteredMessages[filteredMessages.length - 1];
        if (lastMessage) {
          let lastMessageFormatted = '';
          if (lastMessage.origin) {
            lastMessageFormatted = 'Tu: ';
          }
          if (lastMessage.text.includes('<span class="image-caption">')) {
            lastMessageFormatted += this.removeHtmlTags(lastMessage.text);
          } else if (lastMessage.text.includes('<audio controls')) {
            lastMessageFormatted += 'Audio';
          } else {
            lastMessageFormatted += this.removeHtmlTags(this.removeImgTags(lastMessage.text));
          }
          return lastMessageFormatted;
        }
      }
      return '';
    },
    reassign(id) {
      this.$emit('reasign', id);
    },
    assign(id) {
      EventBus.$emit('openAssignDialog', id);
    },
    update(id, type) {
      let body = {};
      if (type === 'readed') {
        const index = this.chats.findIndex(item => item.id === id);
        this.chats[index].unread_messages = 0;
        body = {
          unread_messages: 0,
        };
      } else {
        body = {
          answered_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
      }
      this.axios.patch(`chats_center/${id}`, body).catch((error) => {
        if (error.response.status === 404) {
          EventBus.$emit('modal', 'Este chat ya fue eliminado');
        }
      });
    },
    confirm(id, type) {
      EventBus.$emit('openConfirmDialog', id, type);
    },
    updateScrollbar() {
      this.$refs.chatListScrollbar.update();
    },
  },
};
</script>

<style scoped>
.chat-history--scrollbar > div {
  height: calc(100vh - 90px - 48px - 46px);
}
.chat-history--scrollbar.admin > div {
  height: calc(100vh - 90px - 45px - 40px - 48px);
}
.chat-history--scrollbar > div.show-search {
  height: calc(100vh - 90px - 48px - 46px - 61px);
}
.chat-history--scrollbar.admin > div.show-search {
  height: calc(100vh - 90px - 45px - 40px - 48px - 61px);
}
.little-text{
  font-size: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center/ChatsList.vue